import { RESOURCE } from "../../../../routes/const";

export default () => {
  const rules = [];

  rules.push({
    action: "manage",
    subject: RESOURCE.creative.nested.catalog,
  });
  rules.push({
    action: "manage",
    subject: RESOURCE.creative.nested.artists,
  });
  return rules;
};
